export function getStickyElHeights(selectors = []) {
    return selectors.reduce((total, selector) => {
        const el = document.querySelector(selector);
        return total + (el?.offsetHeight || 0);
    }, 0);
}

export function setRootCssVar(varName, value) {
    document.documentElement.style.setProperty(varName, `${value}px`);
}

/**
 * @param {HTMLElement} container
 * @returns {HTMLElement[]}
 */
export function getFocusableElements(container) {
    const focusableSelector = `
        a[href]:not([tabindex="-1"]),
        area[href],
        input:not([type="hidden"]):not([disabled]):not([tabindex="-1"]),
        select:not([disabled]):not([tabindex="-1"]),
        textarea:not([disabled]):not([tabindex="-1"]),
        button:not([disabled]):not([tabindex="-1"]),
        iframe,
        [tabindex]:not([tabindex="-1"]),
        [contenteditable]:not([contenteditable="false"])
    `;

    const elements = Array.from(container.querySelectorAll(focusableSelector));

    return elements.filter(el => {
        return isElementVisibleOrAccessible(el) && !el.closest('[inert]');
    });
}

function isElementVisibleOrAccessible(el) {
    if (!el) return false;

    const style = window.getComputedStyle(el);
    const rect = el.getBoundingClientRect();
    const ariaHidden = el.getAttribute('aria-hidden');

    const isVisiblyRendered =
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        rect.width > 0 &&
        rect.height > 0;

    const isScreenReaderAccessible =
        ariaHidden !== 'true' &&
        style.display !== 'none' &&
        style.visibility !== 'hidden';

    return isVisiblyRendered && isScreenReaderAccessible;
}

/**
 * @param {KeyboardEvent} e
 * @param {() => HTMLElement[]} getFocusableElementsFn
 */
export function trapFocus(e, getFocusableElementsFn) {
    if (e.key !== 'Tab') return;

    const focusableElements = getFocusableElementsFn();
    const total = focusableElements.length;

    if (total === 0) return;

    e.preventDefault();

    const currentIndex = focusableElements.indexOf(document.activeElement);

    if (e.shiftKey) {
        const targetIndex = currentIndex <= 0 ? total - 1 : currentIndex - 1;
        focusableElements[targetIndex].focus();
    } else {
        const targetIndex = currentIndex === -1 || currentIndex === total - 1 ? 0 : currentIndex + 1;
        focusableElements[targetIndex].focus();
    }
}
